<div class="row p-1">
    <div class="col-12 pageTitle">
        <h2>  &nbsp;&nbsp;&nbsp;Global Setting List</h2>
    </div>
</div>





<div class="field col-12 md:col-12 ml-1 mb-2 card grid" style=" justify-content: space-between;">

    <div class="p-fluid  col-6 md:col-5 lg:col-5 pb-0 pb-0 " style=" align-content: center;">
        <span class="ui-float-label">
            <p-dropdown dataKey="value"
                        [options]="ddlSettingTypeSearch"
                        optionLabel="value"
                        optionValue="key"
                        placeholder="Select Setting Type"
                        class="ui-fluid"
                        [formControl]="settingTypeSearchControl"></p-dropdown>
        </span>

    </div>



    <div class="col-4 md:col-5" style=" align-content: center; text-align: end;">
        <span *ngIf="isQuickPatientDemographicsLink">
            <button pButton type="button" label="Bulk Create" pTooltipPosition="true" icon="pi pi-link" class="ui-button-plain" (click)="QuickLinkMappingPatientDemographics()" title="Quick link  to patient demographics"></button>
        </span>
        &nbsp;<button pButton type="button" label="Create Setting" pTooltipPosition="true" icon="pi pi-plus" class="ui-button-plain  GreyButton" (click)="onAddMappingSetting()" [disabled]="!settingTypeSearchControl.value"></button>
    </div>

</div>
<p-table *ngIf="globalSettingsList"
         [responsive]="true"
         [columns]="cols"
         [value]="globalSettingsList.data"
         selectionMode="single"
         dataKey="settingID"
         [resetPageOnSort]="false"
         [lazy]="false"
         [rows]="rows"
         [paginator]="showRecords"
         (sortFunction)="customSort($event, 1)"
         [customSort]="true">
    <ng-template pTemplate="header" let-columns>
        <tr *ngIf="showRecords == true">
            <ng-template ngFor let-col [ngForOf]="columns" let-i="index">
                <th *ngIf="col.sort == true" [pSortableColumn]="col.field">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
                <th *ngIf="col.sort == false">
                    {{ col.header }}
                </th>
            </ng-template>

            <th class="col-12 md:col-1" style="text-align: left !important">
                Actions
            </th>
          
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
            <td *ngFor="let col of columns">
                <div *ngIf="col.subfield; then nested_object_content; else normal_content"></div>
                <ng-template #nested_object_content>
                    {{ rowData[col.field] }}
                </ng-template>
                <ng-template #normal_content>
                    {{ rowData[col.field] }}
                </ng-template>
            </td>



            <td style="text-align: center !important; display: flex">
                <div class="flex" style="justify-content: center">
                    <button pButton type="button" icon="pi pi-pencil" class="p-button-link" pTooltip="Edit" (click)="onEditGlobalMappingSetting(rowData['settingID'])"></button>
                </div> &nbsp;
                <div class="flex" style="justify-content: center" *ngIf="!isQuickPatientDemographicsLink">
                    <button pButton type="button" icon="pi pi-trash" class="p-button-link ml-3" pTooltip="Delete" (click)="onDelateSettingNameAsPerType(rowData['settingID'])"></button>
                </div>
            </td>

        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <div class="w-12 bg-white">
            <div class="" style="text-align: center">
                <img _ngcontent-ng-c683320295=""
                     class="profile-image"
                     style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                     src="assets/imagesNew/table_error.png" />
            </div>
            <hr style="margin-bottom: 0.5rem" />
            <div class=""
                 style="text-align: center; font-size: larger; color: #1d428f">
                <i>No records found</i>
            </div>
        </div>
    </ng-template>


    <ng-template pTemplate="paginatorleft" let-state>

        <span *ngIf="state.totalRecords > pageSize">
            Showing {{ state.page * state.rows + 1 }} to
            {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
        </span>
    </ng-template>
</p-table>


<p-dialog [(visible)]="displaypopup" [draggable]="false" [modal]="true" [style]="{ width: '36%' }">
    <p-header>
        {{actionType}} Global Setting
    </p-header>
    <div class="">
        <form [formGroup]="frmGlobalSettings" (ngSubmit)="save()">
            <div class="">
                <div class="p-fluid  grid">

                    <div class="field col-12 md:col-12 pt-3">
                        <span class="p-float-label pl-1" style="padding:5px !important">

                            <p-dropdown id="settingType" dataKey="value" [options]="ddlSettingType" appFormErrorMessages optionLabel="value" optionValue="key" placeholder="Select Setting Type" class="textboxBorder-1" formControlName="settingType" appendTo="body" [readonly]="true"></p-dropdown>

                            <label for="ddlSettingType" class="f1">
                                <span class="required-asteric"> * </span> Setting Type
                            </label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-12">
                        <span class="p-float-label pl-1">

                            <p-dropdown id="settingName" dataKey="value" [options]="ddlSettingName" appFormErrorMessages optionLabel="value" optionValue="key" placeholder="Select Setting Name" formControlName="settingName" appendTo="body" [readonly]="!true"></p-dropdown>

                            <label for="ddlSettingName" class="f1">
                                <span class="required-asteric"> * </span> Setting Name
                            </label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-12" *ngIf="selectedSettingType =='MenuItemAlias'">
                        <span class="p-float-label pl-1">
                            <input id="settingValue" type="text" appFormErrorMessages pInputText formControlName="settingValue" />
                            <label for="settingValue" class="f1">
                                <span class="required-asteric"> * </span> Setting Value
                            </label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-12" *ngIf="selectedSettingType =='PatientDemographic'">
                        <span class="p-float-label pl-1">

                            <p-dropdown id="patientDemographicOptions" dataKey="key" [options]="patientDemographicOptions" appFormErrorMessages optionLabel="value" optionValue="value" placeholder="Select Value" class="textboxBorder-1" formControlName="settingValue" appendTo="body" [readonly]="!true"></p-dropdown>
                            <label for="ddlPractice" class="f1">
                                <span class="required-asteric"> * </span> Setting Value
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-12 md:col-12 mt-2" style="text-align: center;">
                <button pButton type="submit" label="Save" icon="pi pi-save" class="p-button-plain buttonWidth-8 fl mr-1"></button>
                <button pButton type="button"
                        icon="pi pi-times-circle"
                        (click)="resetForm();"
                        label="Cancel"
                        class="ui-button-secondary ml-1"></button>
            </div>
        </form>
    </div>


</p-dialog>
